module.exports = __webpack_public_path__ + "static/media/repeater-icon.3e55fcf4.svg";